export default "__VITE_ASSET__CdhInOV___"